
export enum SidebarMode {
  ChooseOffice, ManageDesks
}
